// import OAuth from '@DevimaSolutions/o-auth'
import axios from '@/config/axiosInterceptor'
import { BASE_URLS, ENVIRONMENT_MODE } from '@/config/constants'
import { RefreshShiftsResponseType, ShiftsResponseType } from '@/redux/shifts/types'

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_TASK_URL

export const fetchWorkShiftsList = async (
  hotelID: string,
  date: string,
  type: string,
): Promise<ShiftsResponseType> => {
  const { data } = await axios.get(`${baseURL}getWorkshiftForAllocation/${hotelID}/${date}/${type}`)
  return data?.shifts ?? []
}

// export const refreshWorkShiftsList = (): Promise<RefreshShiftsResponseType> => {
//   return OAuth().axios.post(`/api/manager/refresh-workshifts`)
// }
